'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// HACK: 当 url 中有 disableCache=true 时，禁用 缓存
var DISABLE_CACHE = typeof window !== 'undefined' && typeof location !== 'undefined' ? location.search.indexOf('disableCache=true') > -1 : false;
// HACK: 当 url 中有 showLog=true 时，显示命中日志
var SHOW_LOG = typeof window !== 'undefined' && typeof location !== 'undefined' ? location.search.indexOf('showLog=true') > -1 : false;

// 约定以下参数自动过滤掉
var skipStoreParams = ['callback', 't', '_', '_t'];

// 存储的 key 名
var DATA_KEY = '_data'; // 实际数据
var EXPIRE_KEY = '_expire'; // 过期时间
var IDENTITY_KEY = '_id'; // 惟一性 key

/**
 * protocol :// host : port pathname hash
 * 拼接 params 到 url
 * @param {String} url 原始 url，可包含 param 和 hash,一般异步请求不考虑hash
 *        http://xxxx.com/index#!/steps?step=1
 *        http://xxxx.com/index?step=1#!/steps
 * @param {Object} params 参数
 * @param {Object} options
 * @param {Boolean} options.disableCache 是否禁用缓存，默认为 false，如果禁用 需要在 params 结尾加上 _=timestamp
 * @param {Boolean} options.showLog 是否显示命中日志，默认为 false
 * @param {Function} options.identityKeyFunc 生成缓存标志的函数,用户区分不同用户的数据
 * @param {Function} options.expire 缓存超时时间
 */
var _generateCacheKey = function _generateCacheKey(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var identityKeyFunc = options.identityKeyFunc;

    var identityKey = typeof identityKeyFunc === 'function' ? identityKeyFunc() : 'cache';
    var urlPath = url;
    var paramsPart = '';
    Object.keys(params).forEach(function (key) {
        paramsPart += '&' + key + '=' + params[key];
    });

    if (paramsPart.length > 0) paramsPart = paramsPart.replace(/^&/, '?');

    return [identityKey, urlPath, paramsPart].join('-');
};

/**
 * 从 params 对象中去除 skipedKeys对参数进行排序
 * 返回一个新对象
 */
var stripParams = function stripParams() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var skipedKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return Object.keys(params).sort().filter(function (key) {
        return skipedKeys.indexOf(key) === -1;
    }).reduce(function (result, key) {
        result[key] = params[key];
        return result;
    }, {});
};

var Cache = function () {
    function Cache() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Cache);

        this.store = options.store || new _store2.default();
    }

    /**
     * 生成缓存的 key
     */


    _createClass(Cache, [{
        key: 'generateCacheKey',
        value: function generateCacheKey(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (url.indexOf('?') === -1) {
                return _generateCacheKey(url, stripParams(params, skipStoreParams), options);
            } else {
                // clone
                var mergedParams = _extends({}, params);

                var _url$split = url.split('?'),
                    _url$split2 = _slicedToArray(_url$split, 2),
                    urlPart = _url$split2[0],
                    paramsPart = _url$split2[1];

                // merge


                paramsPart.split('&').forEach(function (paramsStr) {
                    var _paramsStr$split = paramsStr.split('='),
                        _paramsStr$split2 = _slicedToArray(_paramsStr$split, 2),
                        k = _paramsStr$split2[0],
                        v = _paramsStr$split2[1];

                    mergedParams[k] = v;
                });
                return _generateCacheKey(urlPart, stripParams(mergedParams, skipStoreParams), options);
            }
        }

        // 根据 params 来计算过期时间

    }, {
        key: 'generateCacheExpire',
        value: function generateCacheExpire(options) {
            if (options.expire != null) {
                return options.expire + Date.now();
            }
            // 当天结束
            return (0, _util.endOfToday)();
        }

        /**
         * 设置缓存，data 可以为数据或对象
         * @param {string} url
         * @param {object} params
         * @param {object} data 要缓存的数据
         * @param {Object} options
         * @param {Boolean} options.disableCache 是否禁用缓存，默认为 false，如果禁用 需要在 params 结尾加上 _=timestamp
         * @param {Boolean} options.showLog 是否显示命中日志，默认为 false
         * @param {Function} options.identityKeyFunc 生成缓存标志的函数,用户区分不同用户的数据
         * @param {Function} options.expire 缓存超时时间
         */

    }, {
        key: 'setCache',
        value: function setCache(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var data = arguments[2];
            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 禁用缓存或数据为空时不缓存
            if (DISABLE_CACHE || options.disableCache || data == null) {
                return;
            }
            try {
                var _store$set;

                var expireTime = this.generateCacheExpire(options);
                var key = this.generateCacheKey(url, params, options);
                this.store.set(key, (_store$set = {}, _defineProperty(_store$set, DATA_KEY, data), _defineProperty(_store$set, EXPIRE_KEY, expireTime), _defineProperty(_store$set, IDENTITY_KEY, key), _store$set), true);
            } catch (e) {
                console.log(e);
            }
        }

        /**
         * 读取缓存，不存在则返回 null
         * @param {string} url
         * @param {object} params
         * @param {Object} options
         * @param {Boolean} options.disableCache 是否禁用缓存，默认为 false，如果禁用 需要在 params 结尾加上 _=timestamp
         * @param {Boolean} options.showLog 是否显示命中日志，默认为 false
         * @param {Function} options.identityKeyFunc 生成缓存标志的函数,用户区分不同用户的数据
         * @param {Function} options.expire 缓存超时时间
         * @returns {*}
         */

    }, {
        key: 'getCache',
        value: function getCache(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            // 以下参数放在url中无效
            var _options$showLog = options.showLog,
                showLog = _options$showLog === undefined ? false : _options$showLog,
                _options$disableCache = options.disableCache,
                disableCache = _options$disableCache === undefined ? false : _options$disableCache;

            // 禁用缓存则直接返回

            if (DISABLE_CACHE || disableCache) {
                return null;
            }

            try {
                var key = this.generateCacheKey(url, params, options);
                var storeData = this.store.get(key);

                if (!storeData) {
                    return null;
                }

                if (storeData && storeData[DATA_KEY]) {
                    // 检查是否过期
                    if (storeData[EXPIRE_KEY] >= Date.now()) {
                        if (SHOW_LOG || showLog) {
                            console.log('[Request Cache Return] url: ' + url + ', parameter: ' + JSON.stringify(params) + ', result:' + JSON.stringify(storeData[DATA_KEY]));
                        }
                        return storeData[DATA_KEY];
                    } else {
                        this.store.remove(key);
                        return null;
                    }
                }
            } catch (e) {
                console.error(e);
            }
            return null;
        }

        /**
         * 删除缓存
         */

    }, {
        key: 'removeCache',
        value: function removeCache(url, params) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            this.store.remove(this.generateCacheKey(url, params, options));
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.store != null) {
                this.store.destroy();
                this.store = null;
            }
        }
    }]);

    return Cache;
}();

exports.default = Cache;